import { DateHelper } from '../util/dateHelper';
import { Deserializable } from './deserializable';


export class PilomatSystemInfo implements Deserializable {

  serial: string;
  productionDateEpoch: number;
  productionDate: string;
  productionDateDate: Date;
  version: number;
  systemOptions: number;
  name: string;
  model: string;
  reference: string;
  city: string;
  address: string;
  country: string;

  dateFriendly: string;
  dateFriendlyEpoch: string;


  static DEVICE_PILOMAT_MODEL_BOLLARD: string = "Bollard";
  static DEVICE_PILOMAT_MODEL_BARRIER: string = "Barrier";
  static DEVICE_PILOMAT_MODEL_CITYGATE: string = "Citygate";
  static DEVICE_PILOMAT_MODEL_ROADBLOCKER: string = "Roadblocker";

  static MODELS: string[] = [
    PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD,
    PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER,
    PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BARRIER,
    PilomatSystemInfo.DEVICE_PILOMAT_MODEL_CITYGATE
  ];

  deserialize(input: any) {

    Object.assign(this, input);

    if (this.productionDate) {
      this.productionDateDate = DateHelper.parseDate(this.productionDate);
      this.dateFriendly = DateHelper.formatDateFriendly(this.productionDateDate);
    } else {
      this.productionDateDate = new Date(this.productionDateEpoch * 1000);
      this.dateFriendlyEpoch = DateHelper.formatDateFriendly(new Date(this.productionDateEpoch * 1000));
    }

    if(!this.model || this.model == ""){
      this.model = PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD;      
    }

    return this;
  }


}
